import React from 'react';
import { URLS } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import SimpleLink from '@wix/da-shared-react/pkg/SimpleLink';

export type Props = {
  className?: string;
};

export const WhatArePointsLink: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <SimpleLink href={URLS.ABOUT_POINTS} isGreen className={className}>
      {t('common.faq.whatArePoints')}
    </SimpleLink>
  );
};
WhatArePointsLink.displayName = 'WhatArePointsLink';

export default WhatArePointsLink;
